import { render, staticRenderFns } from "./OrderSendWebshopLinks.vue?vue&type=template&id=1ad9843e&"
import script from "./OrderSendWebshopLinks.vue?vue&type=script&lang=js&"
export * from "./OrderSendWebshopLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports